function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", {
  id: "title-eirich-logo"
}, "eirich");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", {
  id: "desc-eirich-logo"
}, "eirich logo");

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M135.65,6.36m0,18.47V6.36h91.24V24.83Z",
  transform: "translate(-6.04 -6.2)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M135.65,43.24m0,18.46V43.24h91.24V61.7Z",
  transform: "translate(-6.04 -6.2)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M135.65,79.72m0,17.93V79.72h91.24V97.65Z",
  transform: "translate(-6.04 -6.2)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M116,116.26l109.89.19c0,60.71-49.11,110.13-109.84,110.13A109.94,109.94,0,0,1,6.14,116.65C6.14,55.94,55.32,6.31,116,6.31Z",
  transform: "translate(-6.04 -6.2)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("polyline", {
  points: "368.22 149.55 368.22 129.28 336.66 129.28 336.66 106.94 365.71 106.94 365.71 86.66 336.66 86.66 336.66 67.72 366.61 67.72 366.61 47.45 313.54 47.45 313.54 149.55 368.22 149.55"
});

var _ref9 =
/*#__PURE__*/
React.createElement("rect", {
  x: 382.3,
  y: 47.45,
  width: 23.12,
  height: 102.1
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M446.78,115.45h8.38q4.5.26,6.33,3.12a16.28,16.28,0,0,1,2.32,7.65,74.56,74.56,0,0,1,.42,10.71q0,6.18.14,13a21.34,21.34,0,0,0,1.35,5.85H490.9l.05-1.35a10.08,10.08,0,0,1-2.25-3.58,123.85,123.85,0,0,1-1.16-15.62q-.39-9.84-1-16.62a14.18,14.18,0,0,0-3.28-8.84,15.89,15.89,0,0,0-8.16-4.38v-.27q7.25-3.53,9.87-9.37a33.13,33.13,0,0,0,2.37-13.89q0-28.71-29.14-28.18h-34.6v102.1h23.14v-40.3m0-43.43A51.05,51.05,0,0,1,455,72a13.37,13.37,0,0,1,5.35,1.47q4.15,2.06,4.15,10.93A20.38,20.38,0,0,1,462.82,93c-1.26,2.62-3.73,4-7.38,4.06h-8.66Z",
  transform: "translate(-6.04 -6.2)"
});

var _ref11 =
/*#__PURE__*/
React.createElement("rect", {
  x: 495.64,
  y: 47.45,
  width: 23.12,
  height: 102.1
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M600.7,89.33V80.75q-.59-29.94-32.29-29.55-32-.14-31.7,32.57v41.87Q536.05,157.8,567,158.2q34.66-.93,34.13-29.83V115.88H578v9.25a31.12,31.12,0,0,1-1.25,9.72q-1.74,4.86-8,5-9.26-.14-9-9.12l.14-50.57q0-5.13,2-8c1.35-1.82,3.92-2.68,7.73-2.59q7.67,0,7.94,13.17v6.59H600.7",
  transform: "translate(-6.04 -6.2)"
});

var _ref13 =
/*#__PURE__*/
React.createElement("polyline", {
  points: "630.88 149.55 630.88 107.07 648.34 107.07 648.34 149.55 671.48 149.55 671.48 47.45 648.34 47.45 648.34 86.81 630.88 86.81 630.88 47.45 607.76 47.45 607.76 149.55 630.88 149.55"
});

var SvgEirich = function SvgEirich(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": "title-eirich-logo desc-eirich-logo",
    viewBox: "0 0 671.48 220.49",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", {
    id: "title-eirich-logo"
  }, title) : null, _ref3, _ref4, React.createElement("path", {
    d: "M135.65,6.36m0,18.47V6.36h91.24V24.83Z",
    transform: "translate(-6.04 -6.2)",
    style: {
      fill: "none",
      stroke: "#0054a6",
      strokeMiterlimit: 3.864000082015991,
      strokeWidth: "0.2150000035762787px"
    }
  }), _ref5, React.createElement("path", {
    d: "M135.65,43.24m0,18.46V43.24h91.24V61.7Z",
    transform: "translate(-6.04 -6.2)",
    style: {
      fill: "none",
      stroke: "#0054a6",
      strokeMiterlimit: 3.864000082015991,
      strokeWidth: "0.2150000035762787px"
    }
  }), _ref6, React.createElement("path", {
    d: "M135.65,79.72m0,17.93V79.72h91.24V97.65Z",
    transform: "translate(-6.04 -6.2)",
    style: {
      fill: "none",
      stroke: "#0054a6",
      strokeMiterlimit: 3.864000082015991,
      strokeWidth: "0.2150000035762787px"
    }
  }), _ref7, React.createElement("path", {
    d: "M116,116.26l109.89.19c0,60.71-49.11,110.13-109.84,110.13A109.94,109.94,0,0,1,6.14,116.65C6.14,55.94,55.32,6.31,116,6.31Z",
    transform: "translate(-6.04 -6.2)",
    style: {
      fill: "none",
      stroke: "#0054a6",
      strokeMiterlimit: 3.864000082015991,
      strokeWidth: "0.2150000035762787px"
    }
  }), _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEirich, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eirich.8d019bb2.svg";
export { ForwardRef as ReactComponent };